var _style, _path, _rect, _defs, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _defs2, _line3, _line4, _path8, _path9, _line5, _path10, _path11, _defs3, _path12, _path13, _path14, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 206.8 206.8",
    style: {
      enableBackground: "new 0 0 206.8 206.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E8ECEF;}\n\t.st2{clip-path:url(#SVGID_00000119076404195634932850000003607220791618517901_);}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:2.7286;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{clip-path:url(#SVGID_00000152253954321114197190000012110735284931889543_);}\n\t.st5{clip-path:url(#SVGID_00000152971026754262470400000011241725973886332321_);}\n\t.st6{fill:#C6E1C3;}\n\t.st7{fill:#619ED6;}\n\t.st8{fill:#EA5152;}\n\t.st9{fill:none;stroke:#010202;stroke-width:2.0745;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#010202;stroke-width:2.0745;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st11{fill:#E16E2D;}\n\t.st12{fill:none;stroke:#010202;stroke-width:2.3345;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#010202;stroke-width:2.3345;stroke-miterlimit:10;}\n\t.st14{fill:#333333;stroke:#010202;stroke-width:2.3345;stroke-miterlimit:10;}\n\t.st15{fill:#010202;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "mappa"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_510",
    className: "st0",
    d: "M24.3,17.5h158.3c3.8,0,6.8,3.1,6.8,6.8v158.3c0,3.8-3.1,6.8-6.8,6.8H24.3 c-3.8,0-6.8-3.1-6.8-6.8V24.3C17.5,20.5,20.5,17.5,24.3,17.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1109",
    transform: "translate(-1003.319 -397.902)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_511",
    x: 1026.2,
    y: 420.8,
    className: "st1",
    width: 161,
    height: 161
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1104",
    transform: "translate(1007.319 401.902)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 18.9,
    y: 18.9,
    width: 161,
    height: 161
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177459241390625991870000018421187282262376600_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1103",
    transform: "translate(0)",
    style: {
      clipPath: "url(#SVGID_00000177459241390625991870000018421187282262376600_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1870",
    className: "st3",
    d: "M-241.5,39.5l230-26.6L165.5-0.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1871",
    className: "st3",
    d: "M136.6,1.5l17.1,6.6L158,29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1872",
    className: "st3",
    d: "M165.1,428.9L88.5,7.4l8.6-86.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1873",
    className: "st3",
    d: "M127,523.4l163.6-171.2l3.8-22.8L158.1,75.8l1.9-54.7l11.3-24.7l44.9-81.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1874",
    className: "st3",
    d: "M158,76l-53.9,17.3l-119.2,23.9l-234.3,52.2"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1875",
    className: "st3",
    d: "M1099.4,428.9l-36.5,7.9l-3,20.4l8.4,46.6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Linea_171",
    className: "st3",
    x1: 1065.9,
    y1: 490.3,
    x2: 1089,
    y2: 486.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Linea_172",
    className: "st3",
    x1: 1062.9,
    y1: 479.5,
    x2: 1038,
    y2: 484
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1106",
    transform: "translate(1007.319 401.902)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023257593842165938950000008684221041015778464_",
    x: 18.9,
    y: 18.9,
    width: 161,
    height: 161
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090987467704441382300000007040978007749858234_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023257593842165938950000008684221041015778464_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1105",
    transform: "translate(0)",
    style: {
      clipPath: "url(#SVGID_00000090987467704441382300000007040978007749858234_)"
    }
  }, _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Linea_173",
    className: "st3",
    x1: 52.7,
    y1: 53.6,
    x2: 25.8,
    y2: 58.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Linea_174",
    className: "st3",
    x1: 67.7,
    y1: 32.3,
    x2: 64.5,
    y2: 8.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1876",
    className: "st3",
    d: "M118.5,167.5l47-12.3l5.1-8.3l8.6-31.7"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1877",
    className: "st3",
    d: "M1120.8,546.7l30.3-8.9l5.4,23.6"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Linea_175",
    className: "st3",
    x1: 1151.1,
    y1: 537.7,
    x2: 1144,
    y2: 484.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1878",
    className: "st3",
    d: "M1118.1,531.5l-20.5-10.7l-51,8.6l-5.9-8.6l-2.7-10.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1879",
    className: "st3",
    d: "M1079.7,523.8l8,49.8l36-2.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1108",
    transform: "translate(1007.319 401.902)"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181062606035439445170000017402703616001785015_",
    x: 18.9,
    y: 18.9,
    width: 161,
    height: 161
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014617032588083612180000012533929588030225827_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181062606035439445170000017402703616001785015_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1107",
    transform: "translate(0)",
    style: {
      clipPath: "url(#SVGID_00000014617032588083612180000012533929588030225827_)"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1880",
    className: "st3",
    d: "M76,144.7c0-0.3-26.8,2.9-26.8,2.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1881",
    className: "st6",
    d: "M109,86.3L99.3,31l54-3.5L151.9,74L109,86.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1882",
    className: "st7",
    d: "M92.7,91.3c-0.1-6-5-10.9-11-10.9c-0.1,0-0.2,0-0.2,0c-5.9,0.1-10.7,5-10.8,10.9 c0,0,0,0.1,0,0.1c0,3.4,2.9,9.4,4.6,12.6c1.1,2.1,2.3,4.2,3.3,5.7c1.5,2.3,2.2,2.9,2.9,3c0.1,0,0.2,0,0.2,0 c0.8,0,1.5-0.4,3.1-3c1-1.6,2.2-3.6,3.3-5.7c1.7-3.2,4.6-9.2,4.6-12.6C92.7,91.4,92.7,91.3,92.7,91.3 M81.7,96.2 c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9S84.4,96.2,81.7,96.2L81.7,96.2"
  })))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "testa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1102",
    transform: "translate(870.071 513.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1859",
    className: "st8",
    d: "M-732-425.1c1,0.8,1.7,1.9,2,3.1c0.2,1.1,0.2,2.2-0.2,3.3c-0.5,0.9-1.4,1.5-2.4,1.7 c-1.3,0.2-2.5-0.4-3.2-1.4c0.2-1.1,0.3-2.1,0.1-3.2c-0.3-1.5-1-2.9-2.1-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1860",
    className: "st9",
    d: "M-732-425.1c1,0.8,1.7,1.9,2,3.1c0.2,1.1,0.2,2.2-0.2,3.3c-0.5,0.9-1.4,1.5-2.4,1.7 c-1.3,0.2-2.5-0.4-3.2-1.4c0.2-1.1,0.3-2.1,0.1-3.2c-0.3-1.5-1-2.9-2.1-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1861",
    className: "st10",
    d: "M-734.1-425.2c0.5,0.5,0.8,1.2,1.1,1.8c0.4,1.1,0.4,2.3,0.1,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1862",
    className: "st11",
    d: "M-754.8-454.1c3.8-3.7,7.5-7.4,11.3-11.1c0.8,2.3,1.1,4.7,0.8,7.1 c-0.3,2.5-1.1,4.8-2.4,6.9c-0.6,0.8-1.1,1.6-1.7,2.4C-749.5-450.6-752.2-452.4-754.8-454.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1863",
    className: "st12",
    d: "M-754.8-454.1c3.8-3.7,7.5-7.4,11.3-11.1c0.8,2.3,1.1,4.7,0.8,7.1 c-0.3,2.5-1.1,4.8-2.4,6.9c-0.6,0.8-1.1,1.6-1.7,2.4C-749.5-450.6-752.2-452.4-754.8-454.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1864",
    className: "st0",
    d: "M-764.1-430.5c2.6,1.8,5.4,3.4,8.2,4.7c2.6,1.2,5.3,2.2,8,3c4.3,1.3,8.9,1.4,13.3,0.3 c3.8-1.1,7.2-3.1,9.9-5.9c1.2-1.3,2.2-2.8,2.9-4.4c0.6-1.2,1.1-2.6,1.4-3.9c-11.5-6.2-23.1-12.5-34.7-18.8c-4.7,1-8.7,3.9-11,8.1 C-768.6-441.8-767.9-435.3-764.1-430.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1865",
    className: "st11",
    d: "M-745.2-438.2c-1.2,3.8-5.6,6.8-9.2,7.8c-1.6,0.4-3.2,0.5-4.8,0.5 c-2-0.2-3.9-0.8-5.7-1.8c-0.8-2.1-1.6-4.2-2.4-6.2l0.8-7.7l3.9-5.8c1.1-0.8,2.2-1.6,3.3-2.4c0.7-0.2,1.4-0.5,2.2-0.7 C-748.1-451.5-743.6-443.6-745.2-438.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1866",
    className: "st11",
    d: "M-748.8-451.9l21.6,15.8l7-0.5L-748.8-451.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1867",
    className: "st13",
    d: "M-764.1-430.5c2.6,1.8,5.4,3.4,8.2,4.7c2.6,1.2,5.3,2.2,8,3c4.3,1.3,8.9,1.4,13.3,0.3 c3.8-1.1,7.2-3.1,9.9-5.9c1.2-1.3,2.2-2.8,2.9-4.4c0.6-1.2,1.1-2.6,1.4-3.9c-11.5-6.2-23.1-12.5-34.7-18.8c-4.7,1-8.7,3.9-11,8.1 C-768.6-441.8-767.9-435.3-764.1-430.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Naso",
    className: "st14",
    d: "M-720.6-436.4c-3.5,0.4-7.1,0.8-10.7,1.2c0.3,2.2,1.7,4,3.8,4.7 C-724.8-429.8-721.1-432.2-720.6-436.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1868",
    className: "st11",
    d: "M-756.3-452.2l-9.8-7.8c-2.8,1.7-5,4.1-6.6,6.9c-1.8,3.3-2.5,7.1-2.1,10.8 c0.9,2.6,1.8,3.1,2.5,3.2c1.9,0.2,3-3.7,7.5-7.5c1.3-1.1,2.6-2.1,4.1-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1869",
    className: "st12",
    d: "M-756.3-452.2l-9.8-7.8c-2.9,1.5-5.2,3.9-6.7,6.9c-1.3,2.6-1.8,5.5-1.6,8.4 c0.5,4.4,1.3,5.4,2,5.6c1.5,0.3,2.8-3.5,7.5-7.5c1.3-1.1,2.7-2,4.1-2.9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_490",
    className: "st0",
    cx: -756.2,
    cy: -442,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_491",
    className: "st15",
    cx: -754.9,
    cy: -441.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_492",
    className: "st0",
    cx: -753.6,
    cy: -442.4,
    rx: 1.9,
    ry: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/currentLocation.7c527105bad3a2f9446a7b38c18d816a.svg";
export { ForwardRef as ReactComponent };